import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class ServidorApi {
  cancelTokens = {
    getServidores: null,
    getServidor: null,
    setServidor: null,
    destroyServidor: null,
    getDadosRhNet: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getServidores({ page = 1, qtd_por_pagina, nome, cpf , unidade_id, exclude_id, exclude_representantes,}) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
      cpf,
      unidade_id,
      exclude_id,
      exclude_representantes,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getServidores = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getServidores = null;
    return data;
  }

  async getServidor(servidorId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getServidor = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}`,
      { cancelToken: source.token }
    );

    this.cancelTokens.getServidor = null;

    // Normaliza o nome do campo antes de retornar
    return {
      ...data,
      lotacoesServidorForm: data.lotacao_servidores || [],
    };
  }

  async destroyServidor(servidorId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.destroyServidor = source;

    try {
      const { data } = await axiosInstance.delete(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}`,
        { cancelToken: source.token }
      );
      return data;
    } finally {
      this.cancelTokens.destroyServidor = null;
    }
  }
  
// Chamar histórico de avaliações do servidor
  async getHistoricoServidor(servidorId) {
    const { data } = await axiosInstance.get(      
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}/historico`
    );
    return data;
  }

  async getUnidades() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getUnidades = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/unidades`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getUnidades = null;

    return data;
  }

  async getServidoresValidos(formularioId) {
    // Cancela requisição anterior, se existir
    if (this.cancelTokens.getServidoresValidos) {
      this.cancelTokens.getServidoresValidos.cancel();
    }
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    this.cancelTokens.getServidoresValidos = source;

    try {
      const { data } = await axiosInstance.get(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/validos_para_formulario`,
        {
          params: { formulario_id: formularioId },
          cancelToken: source.token,
        }
      );

      return data;
    } finally {
      // Limpa o token após a requisição
      this.cancelTokens.getServidoresValidos = null;
    }
  }

  async setServidor(servidor) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setServidor = source;

    if (servidor.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidor.id}`,
        { servidor }, // 👈 Rails exige wrapper
        { cancelToken: source.token }
      );
      this.cancelTokens.setServidor = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores`,
        { servidor }, // 👈 idem
        { cancelToken: source.token }
      );
      this.cancelTokens.setServidor = null;
      return data;
    }
  }

  async getDadosRhNet(cpf) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getDadosRhNet = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/buscar_dados_rh_net.json?cpf=${cpf}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getDadosRhNet = null;
    return data;
  }
  
  async atualizarServidorPublico(cpf, servidorPublico) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.atualizarServidorPublico = source;

    const { data } = await axiosInstance.put(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/atualizar_servidor_publico`,
      {
        cpf: cpf,
        servidor_publico: servidorPublico
      },
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.atualizarServidorPublico = null;
    return data;
  }

  // NOVO MÉTODO: Gerar PDF com TODOS os formulários respondidos pelo servidor
  async gerarPdfHistoricoGeral(servidorId) {
    return axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}/gerar_pdf_historico`,
      { responseType: 'blob' }
    );
  }
  
  async gerarPdfRespostas(formularioId, servidorId) {    
    return axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}/formularios/${formularioId}/gerar_pdf`,
      {
        responseType: 'blob' 
      }
    );
  }

  async getRespostasComoAvaliador(servidorId, formularioId) {
    const response = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/servidores/${servidorId}/formularios/${formularioId}/respostas_como_avaliador`
    );
    return response.data;
  }
  
}

export default ServidorApi;